<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
     
    <a-switch v-model:checked="checked" @change="checkedChange" />
    <p style="margin-top: 10px;">是否开启会员协议</p>
     
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <membershipAgreementContent
          ref="aaa"
          :formInline="formInline"
        ></membershipAgreementContent>
      </div>
    </a-layout-content>
  </div>
</template>

<script>
import membershipAgreementContent from '@/views/systemManagement/membershipAgreement/membershipAgreementContent.vue';
import {enableAgreement,updateAgreement} from '@/api/admin.js';
import { message } from 'ant-design-vue';

export default {
  components: {
    membershipAgreementContent,
  },
  data() {
    return {
      formInline: {
        
      },
      checked: false,
      
    };
  },
  computed: {
   
  },
  created() {
    this.getEnable();
  },
  methods: {
    async checkedChange() {
      // console.log('checkedChange', this.checked);
      const res = await updateAgreement({is_enable: this.checked});
      // console.log('checkedChange',res);
      if(res.success){
        // 如果更新成功，不需要翻转状态
        // this.checked = !this.checked; // 注释掉这行，因为成功更新后状态应该是当前值
        this.getEnable();
      } else {
        // 如果更新失败，可以考虑提示用户或回滚状态
        message.error('更新失败,显示状态回滚');
        this.checked = !this.checked;
      }
    },
    async getEnable(){
      const res = await enableAgreement();
      // console.log('getEnable',res);
      if(res.success && res.data){
        this.checked = res.data.is_enable;
      }
    },
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/membershipAgreement/membershipAgreementHome.vue